import EbzCarousel from './EbzCarousel';

export default EbzCarousel;
